// Spiral: the pipeline's tube, one arm winding down its depth (unwind 0), one palette colour. Width is the arm's share of the pitch down the axis (width + spacing, one radius at the initial); twist scales the arm's depth.
export default {
	name: 'spiral',
	label: 'Spiral',
	description: 'Rolling spiral tunnel of one winding arm',

	expose: {
		speed: {
			tip: 'How fast the spiral rolls; negative draws it the other way',
			step: 0.01,
			period: 2,
			initial: 1,
			minimum: -8,
			maximum: 8,
		},
		zoom: {
			tip: 'Zooms the whole tunnel',
			minimum: 0.25,
			maximum: 4,
		},
		count: {
			tip: 'Windings of the arm from the mouth; All runs it down the whole tunnel',
			initial: 30,
		},
		width: {
			tip: 'Thickness of the arm; the rest of the pitch is Ground',
			initial: 50,
			minimum: 5.5,
			maximum: 200,
			step: 0.05,
		},
		twist: {
			tip: 'How tightly the arm winds into the depth; negative winds the other way',
			initial: 1,
			minimum: -4,
			maximum: 4,
			step: 0.01,
		},
		color: {
			tip: 'The arm’s colour; Wash fades it on through the palette',
			initial: '#ff5e62',
		},
		color_b: {
			label: 'Color 2',
			tip: 'Last palette colour',
			initial: '#ffb547',
		},
		spread: {
			tip: 'Number of colours Wash fades through, from Color to Color 2',
			initial: 5,
		},
		repeat: {
			tip: 'Ramp restarts the palette, Mirror walks back',
			initial: 1,
		},
		wash: {
			tip: 'Fades the arm through the palette, colours per second',
			initial: 0,
			period: 1,
		},
		ground: {
			tip: 'Between the windings and down the tunnel: its colour and opacity',
			initial: '#000000',
		},
	},

	// Fog darkens the mouth to the ground; perspective 2 puts the eye one radius behind the mouth.
	lock: { enclose: 1, tunnel: 1, rounding: 1, fit: 0, spacing: 50, fog: 0.6, unwind: 0, perspective: 2 },
	range: { tunnel: [0, 1], spacing: [0, 100], fog: [0, 1], pan: [-1000, 1000], perspective: [1, 2] },
}
